module.exports = __webpack_public_path__ + "static/img/sign-in-image.000644d.png";